import { fetchProviderName, LazyProvider } from 'app/components/shared/LazyProvider'

function composeProviderIds(locationId: string, vendorIds: string) {
  const locationKey = locationId.substring(18, 24)
  return vendorIds
    .split(`,`)
    .map((id) => `K-${locationKey}-${id}`)
    .join(`,`)
}

function buildCacheKey(locationId?: string, providerId?: string) {
  if (!locationId || !providerId) return ``
  return `kolla:${composeProviderIds(locationId, providerId)}`
}

export async function getKollaProviderName(locationId: string, vendorIds: string) {
  const cacheKey = buildCacheKey(locationId, vendorIds)
  if (!cacheKey) return ``
  const ids = composeProviderIds(locationId, vendorIds)
  return fetchProviderName(cacheKey, `/api/providers/name?ids=${encodeURIComponent(ids)}`)
}

export function LazyKollaProvider(props: {
  locationId?: string
  providerId?: string
  showIcon?: boolean
  showSpinner?: boolean
}) {
  const cacheKey = buildCacheKey(props.locationId, props.providerId)

  return (
    <LazyProvider
      cacheKey={cacheKey}
      fetchName={() => getKollaProviderName(props.locationId!, props.providerId!)}
      showIcon={props.showIcon}
      showSpinner={props.showSpinner}
    />
  )
}
